export default {
  default: '#001A70',
  defaultSemiTransparent: '#001A7080',
  warning: '#CB0000',
  disabled: '#F0F1F5'
};
